<!-- เอกสารตัวจริง -->
<template>
  <div
    class="container"
    :class="{ 'print-original-only': printMode === 'original', 'print-copy-only': printMode === 'copy' }"
  >
    <!-- ปุ่มพิมพ์ - ซ่อนเมื่อพิมพ์ / แยกพิมพ์ต้นฉบับหรือสำเนาอย่างเดียวได้ -->
    <div class="print-btn-wrapper mb-4 d-flex flex-wrap align-center" style="gap: 12px;">
      <v-btn
        class="print-btn print-btn-main"
        @click="doPrint"
      >
        <v-icon left>mdi-printer</v-icon>
        พิมพ์ทั้งหมด
      </v-btn>
      <v-btn
        class="print-btn print-btn-original"
        @click="doPrintSection('original')"
      >
        <v-icon left>mdi-file-document</v-icon>
        พิมพ์ต้นฉบับอย่างเดียว
      </v-btn>
      <v-btn
        class="print-btn print-btn-copy"
        @click="doPrintSection('copy')"
      >
        <v-icon left>mdi-file-document-outline</v-icon>
        พิมพ์สำเนาอย่างเดียว
      </v-btn>
    </div>

    <!-- ต้นฉบับ: หัวบิลเต็มซ้ำทุกหน้า (แบ่งหน้าใน JS แต่ละหน้ามีหัวบิล + แถวสินค้าส่วนนั้น) -->
    <div class="invoice-section invoice-section-original">
      <div
        v-for="(page, pageIndex) in originalPages"
        :key="'orig-page-' + pageIndex"
        class="invoice-print-page"
        :class="{ 'invoice-print-page-last': page.isLast }"
      >
        <!-- หัวบิลเต็ม (ซ้ำทุกหน้า เท่ากันทุกหน้า) -->
        <div class="invoice-header-block">
          <div class="page-counter page-number">ต้นฉบับ</div>
          <v-row>
            <v-col cols="2">
              <v-img width="96" height="100" :lazy-src="seller.logo_invoice" :src="seller.logo_invoice"></v-img>
            </v-col>
            <v-col cols="10" style="flex: 0 0 83.333333%; max-width: 83.333333%">
              <div class="font-14">บริษัท ฟาร์มาแคร์ พลัส จำกัด เลขที่สาขา : {{ seller.tax_invoice_code }}</div>
              <div class="font-14">{{ seller.address }} {{ seller.address_list }}</div>
              <div class="font-14">{{ seller.owner_name }}   โทร {{ seller.tel }}</div>
              <div class="font-14">เลขประจำตัวผู้เสียภาษีอากร {{ seller.store_personal_id }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12 bold font-16 pt-5 pb-8 d-block text-center">
              <div class="text-center">ใบเสร็จรับเงิน / ใบกำกับภาษี</div>
              <div class="text-center">Receipt / Tax Invoice</div>
              <div class="text-center font-14 text-grey" style="margin-top: 10px">
                เลขที่ใบกำกับภาษี : {{ data_list.tax_invoice_code }}
              </div>
            </v-col>
          </v-row>
          <v-row class="border-tax py-3 mb-5 input-radius" style="margin-bottom: 10px">
            <v-col cols="6 pb-1 font-14 text-grey"
              >ชื่อผู้ซื้อ :
              {{ data_list.buyer_name == null ? "-" : data_list.buyer_name }} {{ data_list.branch_number }}</v-col
            >
            <v-col cols="6 pb-1 font-14 text-grey"
              >วันที่ :
              {{
                `${data_list.doc_date.split("-")[2]}
                ${formatMonth(data_list.doc_date.split("-")[1])}
                ${parseFloat(data_list.doc_date.split("-")[0]) + 543}`
              }}</v-col
            >
            <v-col cols="6 pt-1 font-14 text-grey"
              >ที่อยู่ :
              {{ data_list.address == null ? "-" : data_list.address }}</v-col
            >
            <v-col cols="6 pt-1 font-14 text-grey"
              >เลขประจำตัวผู้เสียภาษี :
              {{ data_list.tax_number == null ? "-" : data_list.tax_number }}</v-col
            >
          </v-row>
        </div>
        <!-- ตาราง: หัวคอลัมน์ + แถวสินค้าเฉพาะหน้านี้ -->
        <table class="invoice-print-table invoice-data-table">
          <thead>
            <tr class="invoice-col-header">
              <th class="text-center font-12 text-grey invoice-col-no">ลำดับ / No.</th>
              <th class="text-left font-12 text-grey invoice-col-desc">รายการสินค้า / Description</th>
              <th class="text-center font-12 text-grey invoice-col-qty">จำนวน / Quantity</th>
              <th class="text-right font-12 text-grey invoice-col-disc">ส่วนลด / Discount</th>
              <th class="text-right font-12 text-grey invoice-col-price">ราคาต่อหน่วย / Unit Price</th>
              <th class="text-right font-12 text-grey invoice-col-amount">จำนวนเงิน (บาท)</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, i) in page.rows"
              :key="'orig-' + (pageIndex * ROWS_PER_PAGE + i)"
              class="border-tax invoice-product-row"
            >
              <td class="text-center">{{ pageIndex * ROWS_PER_PAGE + i + 1 }}</td>
              <td class="invoice-desc-cell">{{ item.product_name }}</td>
              <td class="text-center">{{ item.qty }} ({{ item.unit_name }})</td>
              <td class="text-right">{{ formatPrice(item.discount) }}</td>
              <td class="text-right">{{ formatPrice(item.price) }}</td>
              <td class="text-right">{{ formatPrice(item.total) }}</td>
            </tr>
            <template v-if="page.isLast">
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">รวมเงิน (Sub Total)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.total) }}</td>
              </tr>
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">ส่วนลดท้ายบิล (Discount)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.discount) }}</td>
              </tr>
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">มูลค่าสินค้า (Total)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.cost) }}</td>
              </tr>
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">ภาษีมูลค่าเพิ่ม (VAT) 7%</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.vat) }}</td>
              </tr>
              <tr
                v-if="data_list.credit_charge_status == 1 && data_list.pay_type && data_list.pay_type.find((item) => item === 3)"
              >
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">เครดิตชาร์จ (Credit Charge) {{ data_list.credit_charge }}%</td>
                <td class="h-40 text-right font-12">{{ data_list.credit_charge_status == 0 ? formatPrice(0) : formatPrice(data_list.credit_charge_cost) }}</td>
              </tr>
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">คะแนนส่วนลด (Discount points)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.use_point) }}</td>
              </tr>
              <tr>

                <td class="font-12 h-40" colspan="2" style="text-align: right">{{ data_list.net_total_text }}</td>
                <td colspan="3" class="font-12 h-40">ยอดเงินสุทธิ (NET Total)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.net_total) }}</td>
              </tr>
              <tr>
                <td colspan="6" class="invoice-print-body pt-4">
                  <div class="font-12 text-grey">ชำระสินค้า โดย :</div>
                  <div class="font-12 text-grey">
                    ( {{ data_list.pay_type && data_list.pay_type.includes(1) ? "&#10004;" : "" }} ) เงินสด
                    ( {{ data_list.pay_type && data_list.pay_type.includes(2) ? "&#10004;" : "" }} ) เงินโอน
                    ( {{ data_list.pay_type && data_list.pay_type.includes(5) ? "&#10004;" : "" }} ) เงิน Qrcode
                    ( {{ data_list.pay_type && data_list.pay_type.includes(3) ? "&#10004;" : "" }} ) บัตรเครดิต
                    ( {{ data_list.pay_type && data_list.pay_type.includes(4) ? "&#10004;" : "" }} ) อื่นๆ
                  </div>
                  <div class="font-12 text-grey">หมายเหตุ อ้างอิงใบเสร็จรับเงินอย่างย่อเลขที่ : {{ data_list.invoice_code }}</div>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="font-12 text-grey text-center pt-2">
                  ลงชื่อ ...................................................................... ผู้รับเงิน &nbsp;&nbsp; วันที่ ......................................................................
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- สำเนา: หัวบิลเต็มซ้ำทุกหน้า (แบ่งหน้าเหมือนต้นฉบับ) -->
    <div class="invoice-section invoice-section-copy" style="margin-top: 50px">
      <div
        v-for="(page, pageIndex) in copyPages"
        :key="'copy-page-' + pageIndex"
        class="invoice-print-page"
        :class="{ 'invoice-print-page-last': page.isLast }"
      >
        <!-- หัวบิลเต็ม (ซ้ำทุกหน้า เท่ากันทุกหน้า) -->
        <div class="invoice-header-block">
          <div class="page-counter page-number">สำเนา</div>
          <v-row>
            <v-col cols="2">
              <v-img width="96" height="100" :lazy-src="seller.logo_invoice" :src="seller.logo_invoice"></v-img>
            </v-col>
            <v-col cols="10" style="flex: 0 0 83.333333%; max-width: 83.333333%">
              <div class="font-14">บริษัท ฟาร์มาแคร์ พลัส จำกัด เลขที่สาขา : {{ seller.tax_invoice_code }}</div>
              <div class="font-14">{{ seller.address }} {{ seller.address_list }}</div>
              <div class="font-14">{{ seller.owner_name }}   โทร {{ seller.tel }}</div>
              <div class="font-14">เลขประจำตัวผู้เสียภาษีอากร {{ seller.store_personal_id }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12 bold font-16 pt-5 pb-8 d-block text-center">
              <div class="text-center">ใบเสร็จรับเงิน / ใบกำกับภาษี</div>
              <div class="text-center">Receipt / Tax Invoice</div>
              <div class="text-center font-14 text-grey" style="margin-top: 10px">
                เลขที่ใบกำกับภาษี : {{ data_list.tax_invoice_code }}
              </div>
            </v-col>
          </v-row>
          <v-row class="border-tax py-3 mb-5 input-radius" style="margin-bottom: 10px">
            <v-col cols="6 pb-1 font-14 text-grey"
              >ชื่อผู้ซื้อ :
              {{ data_list.buyer_name == null ? "-" : data_list.buyer_name }} {{ data_list.branch_number }}</v-col
            >
            <v-col cols="6 pb-1 font-14 text-grey"
              >วันที่ :
              {{
                `${data_list.doc_date.split("-")[2]}
                ${formatMonth(data_list.doc_date.split("-")[1])}
                ${parseFloat(data_list.doc_date.split("-")[0]) + 543}`
              }}</v-col
            >
            <v-col cols="6 pt-1 font-14 text-grey"
              >ที่อยู่ :
              {{ data_list.address == null ? "-" : data_list.address }}</v-col
            >
            <v-col cols="6 pt-1 font-14 text-grey"
              >เลขประจำตัวผู้เสียภาษี :
              {{ data_list.tax_number == null ? "-" : data_list.tax_number }}</v-col
            >
          </v-row>
        </div>
        <!-- ตาราง: หัวคอลัมน์ + แถวสินค้าเฉพาะหน้านี้ -->
        <table class="invoice-print-table invoice-data-table">
          <thead>
            <tr class="invoice-col-header">
              <th class="text-center font-12 text-grey invoice-col-no">ลำดับ / No.</th>
              <th class="text-left font-12 text-grey invoice-col-desc">รายการสินค้า / Description</th>
              <th class="text-center font-12 text-grey invoice-col-qty">จำนวน / Quantity</th>
              <th class="text-right font-12 text-grey invoice-col-disc">ส่วนลด / Discount</th>
              <th class="text-right font-12 text-grey invoice-col-price">ราคาต่อหน่วย / Unit Price</th>
              <th class="text-right font-12 text-grey invoice-col-amount">จำนวนเงิน (บาท)</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, i) in page.rows"
              :key="'copy-' + (pageIndex * ROWS_PER_PAGE + i)"
              class="border-tax invoice-product-row"
            >
              <td class="text-center">{{ pageIndex * ROWS_PER_PAGE + i + 1 }}</td>
              <td class="invoice-desc-cell">{{ item.product_name }}</td>
              <td class="text-center">{{ item.qty }} ({{ item.unit_name }})</td>
              <td class="text-right">{{ formatPrice(item.discount) }}</td>
              <td class="text-right">{{ formatPrice(item.price) }}</td>
              <td class="text-right">{{ formatPrice(item.total) }}</td>
            </tr>
            <template v-if="page.isLast">
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">รวมเงิน (Sub Total)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.total) }}</td>
              </tr>
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">ส่วนลดท้ายบิล (Discount)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.discount) }}</td>
              </tr>
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">มูลค่าสินค้า (Total)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.cost) }}</td>
              </tr>
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">ภาษีมูลค่าเพิ่ม (VAT) 7%</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.vat) }}</td>
              </tr>
              <tr
                v-if="data_list.credit_charge_status == 1 && data_list.pay_type && data_list.pay_type.find((item) => item === 3)"
              >
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">เครดิตชาร์จ (Credit Charge) {{ data_list.credit_charge }}%</td>
                <td class="h-40 text-right font-12">{{ data_list.credit_charge_status == 0 ? formatPrice(0) : formatPrice(data_list.credit_charge_cost) }}</td>
              </tr>
              <tr>
                <td class="bb-0 h-40" colspan="2"></td>
                <td colspan="3" class="font-12 h-40">คะแนนส่วนลด (Discount points)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.use_point) }}</td>
              </tr>
              <tr>
                <td class="font-12 h-40" colspan="2" style="text-align: right">{{ data_list.net_total_text }}</td>
                <td colspan="3" class="font-12 h-40">ยอดเงินสุทธิ (NET Total)</td>
                <td class="h-40 text-right font-12">{{ formatPrice(data_list.net_total) }}</td>
              </tr>
              <tr>
                <td colspan="6" class="invoice-print-body pt-4">
                  <div class="font-12 text-grey">ชำระสินค้า โดย :</div>
                  <div class="font-12 text-grey">
                    ( {{ data_list.pay_type && data_list.pay_type.includes(1) ? "&#10004;" : "" }} ) เงินสด
                    ( {{ data_list.pay_type && data_list.pay_type.includes(2) ? "&#10004;" : "" }} ) เงินโอน
                    ( {{ data_list.pay_type && data_list.pay_type.includes(5) ? "&#10004;" : "" }} ) เงิน Qrcode
                    ( {{ data_list.pay_type && data_list.pay_type.includes(3) ? "&#10004;" : "" }} ) บัตรเครดิต
                    ( {{ data_list.pay_type && data_list.pay_type.includes(4) ? "&#10004;" : "" }} ) อื่นๆ
                  </div>
                  <div class="font-12 text-grey">หมายเหตุ อ้างอิงใบเสร็จรับเงินอย่างย่อเลขที่ : {{ data_list.invoice_code }}</div>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="font-12 text-grey text-center pt-2">
                  ลงชื่อ ...................................................................... ผู้รับเงิน &nbsp;&nbsp; วันที่ ......................................................................
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>



  
<script>
import { formatPrice } from "@/js/handler";
import img_arin from "@/assets/arin_assets/arin.png";
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_bill_after",
  data() {
    return {
      loading_page: false,
      dialog_cancel_order: false,
      search: "",
      img_arin: img_arin,
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      data_list: [],
      seller: {},
      printMode: "", // '' | 'original' | 'copy' สำหรับแยกพิมพ์ต้นฉบับ/สำเนา
      ROWS_PER_PAGE: 18, // จำนวนแถวสินค้าต่อหน้า (หัวบิลจะซ้ำทุกหน้า)
    };
  },
  computed: {
    // แบ่งหน้ารายการสินค้า ต้นฉบับ: แต่ละหน้ามีหัวบิลเต็ม + แถวสินค้าส่วนนั้น
    originalPages() {
      const list = this.data_list.product_list || [];
      const per = this.ROWS_PER_PAGE;
      const pages = [];
      for (let i = 0; i < list.length; i += per) {
        pages.push({
          rows: list.slice(i, i + per),
          isLast: i + per >= list.length,
        });
      }
      if (pages.length === 0) pages.push({ rows: [], isLast: true });
      return pages;
    },
    copyPages() {
      return this.originalPages;
    },
  },
  methods: {
    doPrint() {
      this.printMode = "";
      this.$nextTick(() => window.print());
    },
    doPrintSection(mode) {
      this.printMode = mode;
      this.$nextTick(() => window.print());
    },
    clearPrintMode() {
      this.printMode = "";
    },
    link(link) {
      window.location.href = link;
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    formatMonth(value) {
      switch (value) {
        case "01":
          return "มกราคม";
        case "02":
          return "กุมภาพันธ์";
        case "03":
          return "มีนาคม";
        case "04":
          return "เมษายน";
        case "05":
          return "พฤษภาคม";
        case "06":
          return "มิถุนายน";
        case "07":
          return "กรกฏาคม";
        case "08":
          return "สิงหาคม";
        case "09":
          return "กันยายน";
        case "10":
          return "ตุลาคม";
        case "11":
          return "พฤศจิกายน";
        case "12":
          return "ธันวาคม";
      }
    },
    // setPageNumbers() {
    //     let pages = document.querySelectorAll('.invoice-section');
       
    // },
    async getSotre() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let store_id = this.$store.state.store_arin.user_data.store_id;
      await HTTP_ARIN.get("/stores/detail/" + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.seller = res.data.storeDetail;
        }
      });
    },
    async getDetail() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = this.$route.query.id;
      await HTTP_ARIN.get("/invoice/create/taxinvoice/" + id, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.data_list = res.data.data;
            this.data_list.total = 0;
            this.data_list.product_list = this.data_list.product_list.map(
              (item) => {
                if (item.is_promotion == 0) {
                  this.data_list.total += parseFloat(item.total);
                } else if (item.is_promotion == 1) {
                  // ลบ total ของสินค้าที่เป็นโปรโมชั่น
                  this.data_list.total -= parseFloat(item.total);
                }
                return { ...item };
              }
            );
          }
        }
      );
    },
  },
  mounted() {
    this.getSotre();
    this.getDetail();
    window.addEventListener("afterprint", this.clearPrintMode);
    if (this.$route.query.status_print == 1) {
        this.disablePrint();
    }
  },
  beforeDestroy() {
    window.removeEventListener("afterprint", this.clearPrintMode);
  },
};
</script>
  

<style scoped>
@media print {
  @page {
    size: A4;
    counter-increment: page;
  }

  /* แต่ละ "หน้า" ของใบกำกับ: หัวบิลซ้ำทุกหน้า + แถวสินค้าส่วนนั้น */
  .invoice-print-page {
    page-break-after: always;
  }
  .invoice-print-page-last {
    page-break-after: auto;
  }

  .invoice-section {
    page-break-after: always;
  }

  .invoice-data-table {
    page-break-inside: auto;
  }
  .invoice-data-table tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  /* ซ่อนปุ่มพิมพ์เมื่อพิมพ์ */
  .print-btn-wrapper {
    display: none !important;
  }

  /* แยกพิมพ์: แสดงเฉพาะส่วนที่เลือก */
  body.print-original-only .invoice-section-copy,
  .print-original-only .invoice-section-copy {
    display: none !important;
  }
  body.print-copy-only .invoice-section-original,
  .print-copy-only .invoice-section-original {
    display: none !important;
  }
}

/* ปุ่มพิมพ์ให้เด่นชัด - สีเขียว ขนาดใหญ่ */
.print-btn-wrapper {
  padding: 8px 0;
}
.print-btn {
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 12px 24px !important;
  min-height: 48px !important;
  text-transform: none;
  letter-spacing: 0;
}
.print-btn-main {
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88b358 !important;
  color: #fff !important;
  border: none;
  box-shadow: 0 2px 8px rgba(101, 146, 100, 0.4);
}
.print-btn-main:hover {
  box-shadow: 0 4px 12px rgba(101, 146, 100, 0.5);
}
.print-btn-original,
.print-btn-copy {
  background: #5a6b5a !important;
  color: #fff !important;
  border: 2px solid #88b358;
}
.print-btn-original:hover,
.print-btn-copy:hover {
  background: #659264 !important;
  color: #fff !important;
}

.page-number {
  position: relative;  /* ป้องกันการทับกัน */
  display: block;
  margin-top: 1mm;
  text-align: right;
  font-size: 14px;
  font-weight: bold;
  color: #000;
}

.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  /* width: 100%; */
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 36px;
  min-width: 45px;
  padding: 0 10px;
}

/* หัวบิลเต็ม (ซ้ำทุกหน้า) */
.invoice-header-block {
  border: none;
  padding: 0;
  margin-bottom: 0;
}

.invoice-print-table.invoice-data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;
}
.invoice-data-table .invoice-col-header th {
  border: 1px solid #b7b7b7;
  padding: 6px 8px;
  background: #fafafa;
}
/* ความกว้างคอลัมน์: ลด 5 คอลัมน์ให้แคบ ไปเพิ่มที่รายการสินค้า */
.invoice-col-no { width: 36px; min-width: 36px; }
.invoice-col-desc { width: auto; min-width: 120px; }
.invoice-col-qty { width: 58px; min-width: 58px; }
.invoice-col-disc { width: 50px; min-width: 50px; }
.invoice-col-price { width: 62px; min-width: 62px; }
.invoice-col-amount { width: 74px; min-width: 74px; }
.invoice-data-table tbody td {
  border: 1px solid #b7b7b7;
  padding: 4px 8px;
}

/* แถวสินค้า: ตัวอักษรเล็ก + แถวแน่น เพื่อให้ได้ ~18 รายการต่อหน้า ลดการตก 2 บรรทัด */
.invoice-product-row td {
  font-size: 12px !important;
  line-height: 1.2;
  padding: 2px 6px !important;
  vertical-align: middle;
}
.invoice-desc-cell {
  font-size: 11px !important;
  line-height: 1.25;
  word-break: break-word;
}
.border-tax {
  border: 1px solid #b7b7b7;
}

.border-style-b {
  /* border-style: dotted;
    border-color: #ADADAD; */
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px dotted #adadad;
}

.title_page_right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.title_page_center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.font-14 {
  font-size: 14px !important;
}

.font-12 {
  font-size: 12px !important;
}

.h-40 {
  height: 35px !important;
}

.bb-0 {
  border-bottom: 0px !important;
}
</style>
  